import { useEffect, useState } from "react";
import { api, ApiError } from "@/api/client";
import { useStore } from "@/state/store";
import type { Output } from "@offsite/shared";
import { teamLabel } from "@/engine/app/team-label";

export function OutputView({ teamNumber }: { teamNumber: number }) {
  const { state } = useStore();
  const [output, setOutput] = useState<Output | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.overnight.output(state.auth.token, teamNumber);
        if (!cancelled) setOutput(res.output);
      } catch (err) {
        // 404 just means the team's output isn't ready yet — silent.
        if (!(err instanceof ApiError && err.status === 404)) {
           
          console.error("OutputView load failed", err);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [state.auth.token, teamNumber]);

  if (loading) return <p className="form-hint">Lade Ergebnis …</p>;
  if (!output) return <p className="form-hint">Noch kein Ergebnis verfügbar.</p>;

  return (
    <section style={{ display: "grid", gap: 14 }}>
      <header className="output-head">
        <div>
          <div className="deck-eyebrow">KI-Output</div>
          <h2
            className="deck-title"
            style={{ fontSize: "clamp(1.3rem, 4vw, 1.75rem)", margin: "4px 0 0" }}
          >
            Was die KI gebaut hat
          </h2>
          {output.teamName && (
            <p className="form-hint" style={{ marginTop: 4 }}>
              {teamLabel(output.teamNumber)} · {output.teamName}
            </p>
          )}
        </div>
      </header>
      {output.contentType === "html" ? (
        // sandbox="allow-scripts" only — see OutputRenderer.tsx for the
        // full sandbox-policy rationale (no allow-same-origin, no forms,
        // no popups, no top-navigation).
        <iframe
          title={`Output Team ${output.teamNumber}`}
          srcDoc={output.content}
          sandbox="allow-scripts"
          referrerPolicy="no-referrer"
          loading="lazy"
          className="output-frame"
        />
      ) : (
        <pre className="output-pre">{output.content}</pre>
      )}
    </section>
  );
}
